/**
 * @param {Object} props
 * @param {string} props.title
 * @param {string} props.size
 * @param {boolean} props.red
 */
export default function FloatingPanel({ title = "", size = "max-w-6xl", red, children }) {
    return (
        <div className={`border border-neutral-300 rounded-xl w-full mb-8 overflow-hidden bg-neutral-50 drop-shadow-md ${size}`}>
            {title && <div className={`text-center text-2xl p-1.5 font-semibold bg-(--ngf-light-blue) text-white ${red ? "bg-(--ngf-red)" : ""}`}>{title}</div>}
            <div className="p-5 py-6 *:last:mb-0 not-sm:p-3 not-sm:py-4">
                {children}
            </div>
        </div>
    );
}